export default __webpack_public_path__ + "ac04fe44a7ebcb0f6e4d7bee30185d34.png";